import React from "react";
import T from "prop-types";

import { useServerMessage } from "b2b/i18n";
import { PlaceholderText } from "2g-placeholder";

function Title({ loading, provozniInformace }) {
  const serverMessage = useServerMessage();

  return !loading ? (
    serverMessage(provozniInformace, "nazev")
  ) : (
    <PlaceholderText>Název provozní informace</PlaceholderText>
  );
}

Title.propTypes = {
  loading: T.bool,
  provozniInformace: T.shape({
    nazevCs: T.string,
    nazevEn: T.string
  })
};

export default React.memo(Title);
